import { ROUTES } from "../routes/routes.constants";
/**
 * Where to send the user right after login / OTP verification (when there is no deep-link).
 * - Saved `last_visited_page` wins — except for a client whose saved page is Home (the
 *   "Coming Soon" placeholder), which is treated as if nothing was saved.
 * - Client with no usable saved page: paid_media → Account Summary, affiliate → Affiliate
 *   Account Performance (paid_media wins if the client has both types).
 * - Everyone else falls back to Home.
 */
export const getPostLoginPath = (result) => {
    const lastVisited = result?.user?.last_visited_page;
    const isClient = result?.entity_type === "client";
    if (lastVisited && !(isClient && lastVisited === ROUTES.home.path))
        return lastVisited;
    if (isClient) {
        const rawType = result?.user?.client_details?.type;
        const types = (Array.isArray(rawType) ? rawType : [rawType])
            .filter(Boolean)
            .map((t) => String(t).toLowerCase());
        if (types.includes("paid_media"))
            return ROUTES.accountSummary.path;
        if (types.includes("affiliate"))
            return ROUTES.affiliateAccountPerformance.path;
    }
    return ROUTES.home.path;
};
